module.exports = __webpack_public_path__ + "img/PR9274.e19003b1.png";